<template>
    <b-modal
        :title="$t('history.modal.header.ChangeTransitStatus')"
        ref="transit-status-modal"
        @ok="updateTransitStatus"
    >
        <form ref="form">
            <b-form-group :label="$t('history.modal.body.TransitStatus')">
                <vSelect
                    :dynamicWidth="false"
                    :clearable="false"
                    v-model="selectedDeliveryStatus"
                    :options="getDeliverStatusesWithoutUndelivered"
                    :placeholder="$t('createShipment.placeholder.Select Transit Status')"
                    name="transitStatusDropdown"
                />
            </b-form-group>
        </form>

        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button @click="cancel()">Cancel</b-button>
            <b-button @click="ok()" name="changeTransitStatusModalButton" variant="primary">{{
                $t('history.modal.button.Change')
            }}</b-button>
        </template>
    </b-modal>
</template>
<script>
import { CORE_PREFIX, ACTIONS, MUTATIONS, HISTORY_PREFIX } from '@/store/constants';
import helpers from '@/helper';
import { mapGetters } from 'vuex';
import vSelect from '../../vSelect';

export default {
    props: {
        deliveryStatus: { type: String }
    },

    components: {
        vSelect
    },

    data() {
        return {
            selectedDeliveryStatus: null
        };
    },

    computed: {
        ...mapGetters('history', ['getSelectedRows', 'getDeliverStatusesWithoutUndelivered'])
    },

    methods: {
        showTransitStatusModal() {
            this.selectedDeliveryStatus = this.deliveryStatus;

            this.$refs['transit-status-modal'].show();
        },

        updateTransitStatus() {
            this.$emit('updateTransitStatus', this.selectedDeliveryStatus);

            this.selectedDeliveryStatus = null;
        }
    }
};
</script>

<style></style>
